import $ from 'jquery';
import { personalCashbackDetail } from "../queries";

const form = $('.js-dates-chose');
const table = $('.page-personal-cashback-table');
let debounceTimeout;

form.on('submit', async function (event) {
    event.preventDefault();

    // Получаем значения полей даты
    const dateFrom = $('.js-datepicker-from').val();
    const dateTo = $('.js-datepicker-to').val();

    // Проверяем, заполнены ли оба поля даты
    if (!dateFrom && !dateTo) {
        return; // Прекращаем выполнение функции, если хотя бы одно поле не заполнено
    }

    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(async function () {
        table.html('');
        const formData = form.serializeJSON();
        table.addClass('page-personal-cashback-table--loading');
        try {
            const response = await personalCashbackDetail(formData);
            const balanceHistory = response.item.map(entry => {
                const operationClass = entry.operationType === 'plus' ? 'page-personal-cashback-table__item--plus' : 'page-personal-cashback-table__item--minus';
                const operationSign = entry.operationType === 'plus' ? '+' : '-';
                const operationWord = entry.operationType === 'plus' ? 'Начисление' : 'Списание';
                const date = new Date(entry.operationDate);

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы в JavaScript отсчитываются с 0
                const year = date.getFullYear();
                const roundedAmount = Math.floor(Number(entry.amount)); // Округляем сумму вниз

                const formattedDate = `${day}.${month}.${year}`;
                return `
                    <tr class="page-personal-cashback-table__item ${operationClass}">
                        <td style="white-space: nowrap;">${formattedDate}</td>
                        <td style="white-space: nowrap;">${operationWord}</td>
                        <td>
                            <span>${operationSign}${roundedAmount}</span>
                        </td>
                    </tr>
                `;
            });

            table.empty();
            if (response.item.length > 0) {
                table.append(`
                    <tr class="page-personal-cashback-table__item">
                        <td>Дата начисления/ списания</td>
                        <td>Тип операции</td>
                        <td>Начислено/списано бонусов</td>
                    </tr>
                `);

                table.append(balanceHistory);
            } else {
                table.html('<p>За указанный период данных не найдено</p>');
            }

            table.removeClass('page-personal-cashback-table--loading');
        } catch (error) {
            console.error('Error fetching cashback details:', error);
        }
    }, 500);
});
